// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1XHbB","colBig":"styles_colBig__3qAKy","colSmall":"styles_colSmall__1kjyC"};